import React, { useEffect, useState, useRef } from 'react';
import { Form, Container, Alert } from 'react-bootstrap';
import api from '../../../services/client';
import { setValue } from '../../../helpers/localStorageHelper';
import styled from 'styled-components';
import routes from '../../routes';
import { useHistory, useParams } from 'react-router-dom';
import BannerImage from '../../../assets/JobBoard_Banner.png';
import TitleImage from '../../../assets/resetpass.png';
import { merge } from 'lodash';


const Banner = styled.div`
    background-image: url(${BannerImage});
    min-height: 400px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    @media screen and (max-width: 450px) {
        min-height: 225px;
    }
`;
const Title = styled.div`
    background-image: url(${TitleImage});
    min-height: 95px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    width: 65%;    
    margin: 25px auto;
    @media screen and (max-width: 450px) {
        min-height: 60px;
    }
`;

const LoginHeader = styled.div`
    padding: 4% 6%;
`;

const MessageContent = styled.div`
    height: 200px;  
    display: flex;
    justify-content: center;
    align-items: end;
    font-size: 3rem;
    color: #0A3BB4;

    @media screen and (max-width: 768px) {
        font-size: 2rem;
    }
`;

function ResetPassword() {
    const history = useHistory();
    const {resetToken} = useParams();
    const [error, setError] = useState(false);
    const [message, setMessage] = useState();
    const [showReset, setShowReset] = useState(false);
    const [userDetails, setUserDetails] = useState('');
    const fotgotPasswordForm = useRef();

    useEffect(async () => {
        await api.validateResetToken({token: resetToken}).then((result) => {
            setShowReset(true);
            setUserDetails(result.data);
        }).catch((res) => {
          setError(true);
          setShowReset(false);
          setMessage(res?.response?.data?.message ?? "Internal server error");
        })

    },[])

    const handleOnSubmit = async (e) => {
        e.preventDefault();
        setError(false);
        setShowReset(true);
        var formData = new FormData(fotgotPasswordForm.current),
            formDataObj = Object.fromEntries(formData.entries());
        if (formDataObj.Password == formDataObj.ConfirmPassword) {
            console.info(merge(userDetails, {Password: formDataObj.Password, ModifiedDate: new Date()}))
            await api.resetPassword(merge(userDetails, {Password: formDataObj.Password, ModifiedDate: new Date()})).then((result) => {
                setShowReset(false);
                setMessage("Password Reset Successfully!")
              }).catch((res) => {
                setError(true);
                setMessage(res?.response?.data?.message ?? "Internal server error");
              })
        } else {
            setError(true);
            setMessage('Passwords do not match');
        }
    }


    return showReset ? (
        <>
            <Banner />
            <Title />
            <div className='signup-container'>
                <Container>
                    <Form ref={fotgotPasswordForm}>
                        <LoginHeader>
                            <Form.Group className="mb-2" controlId="formBasicPassword">
                                <Form.Control type="password" name="Password" placeholder="Password" required/>
                            </Form.Group>
                            <Form.Group className="mb-2" controlId="formBasicConfirmPassword">
                                <Form.Control type="password" name="ConfirmPassword" placeholder="Confirm Password"  style={{border: `1px solid ${error ? 'red' : '#ced4da'}`}}/>
                                {error && <p className='text-danger' style={{marginBottom:0, marginTop:'5px'}}> {message} </p>}
                            </Form.Group>
                        </LoginHeader>
                    </Form>
                    <button className='btnClass' onClick={handleOnSubmit}>Submit</button>
                </Container>
            </div>
        </>
    ) : (
        <>
            <MessageContent className='text-center'>
                {message}               
            </MessageContent>
            {error && <div className='text-center'>Please check you mail for reset link!</div>}
            
        </>
    )
}

export default ResetPassword

